import { getV1CompaniesCompanyIdServiceClasses } from '@treadinc/horizon-api-spec';
import { useCallback } from 'react';

import { MAX_API_PAGE_SIZE } from '~constants/consts';
import { ServiceClass } from '~hooks/useServiceClass/models';
import { extractPagination, PaginationLink } from '~services/pagination';

interface GetServiceClassesPageParams {
  cursor?: string;
  link?: PaginationLink;
  signal?: AbortSignal;
}

export default function useServiceClass() {
  const getServiceClassesByCompanyId = useCallback(
    async (
      companyId: string,
      { cursor, link, signal }: GetServiceClassesPageParams = {},
    ) => {
      const response = await getV1CompaniesCompanyIdServiceClasses({
        path: { 'company-id': companyId },
        query: {
          // the order and project forms load only the first page, so this also caps
          // their service class options
          'page[limit]': MAX_API_PAGE_SIZE,
          ...(link && cursor ? { [`page[${link}]`]: cursor } : {}),
        },
        signal,
      });

      return {
        data: response.data.data.map(ServiceClass.parse),
        pagination: extractPagination(response),
      };
    },
    [],
  );

  return { getServiceClassesByCompanyId };
}
